// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"a038b5af","42":"c2754cb7","195":"a73b887c","260":"0e77d2a5","535":"28952882","591":"9a7897f3","720":"9e87cf34","722":"d56fb049","739":"dcd0c2b3","897":"4a20a960","950":"21b0a961","981":"847ed978"}[chunkId] + ".chunk.js";
};